














import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { IEnableSpecifiable } from "../../../../../base/domain/drawing";

@Component
export default class OptionalFeatureEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IEnableSpecifiable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IEnableSpecifiable) => T, defaultValue: T) => T;

  @Prop()
  title: string;

  @Prop()
  description: string;

  get isEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isEnable, false);
  }

  set isEnable(value: boolean) {
    this.writePropertyWhenValid(s => s.isEnable = value);
    if (this.value) {
      this.$nextTick(() => this.ready());
    }
  }

  onClicked(): void {
    if (!this.isEnable) {
      this.isEnable = true;
    }
  }

  @Emit()
  ready(): void {}
}
